/* eslint-disable no-loop-func */
// FLOW PERFORMANCE PDF PAGES v1.1
// Fixed: Unicode rendering, node ordering, banner width, column layout
import autoTable from "jspdf-autotable";

var NAVY = [26, 39, 68], GRAY = [100, 100, 100];
var GREEN = [5, 150, 105], WHITE = [255, 255, 255];
var VER = "2.3.0";

function fmtDate() { return new Date().toISOString().replace("T", " ").slice(0, 19); }

function addFooter(doc, pg) {
  var pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight();
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text("Software Version " + VER + "    Calculation Performed: " + fmtDate() + " EST", pw / 2, ph - 15, { align: "center" });
  doc.text("Page " + pg, pw - 20, ph - 15, { align: "right" });
  doc.text("Copyright \u00A9 Boal Systems Inc. Fort Lauderdale, FL USA", pw / 2, ph - 10, { align: "center" });
}

function addLogo(doc, logoB64, logoFmt, x, y, w, h) {
  try {
    if (logoB64) {
      doc.setFillColor(255, 255, 255);
      doc.rect(x, y, w, h, "F");
      doc.addImage(logoB64, logoFmt || "JPEG", x, y, w, h);
    }
  } catch (e) {}
}

// Sort node keys in logical order: cyl, hose_end, then numeric
function sortNodeKeys(keys) {
  var order = { cyl: 0, hose_end: 1 };
  return keys.sort(function(a, b) {
    var oa = order[a] !== undefined ? order[a] : 100;
    var ob = order[b] !== undefined ? order[b] : 100;
    if (oa !== ob) return oa - ob;
    // Both are numbered nodes — extract number
    var na = parseInt(a.replace(/[^0-9]/g, "")) || 999;
    var nb = parseInt(b.replace(/[^0-9]/g, "")) || 999;
    return na - nb;
  });
}

export function addFlowPerformancePages(doc, enclosureResults, flowResults, logoBase64, logoFormat, startPage) {
  if (!flowResults || Object.keys(flowResults).length === 0) return startPage;

  var hasAnyVerified = false;
  for (var k in flowResults) {
    if (flowResults[k] && flowResults[k].passed) { hasAnyVerified = true; break; }
  }
  if (!hasAnyVerified) return startPage;

  var pg = startPage, pw = doc.internal.pageSize.getWidth(), m = 20;

  for (var idx = 0; idx < enclosureResults.length; idx++) {
    var fr = flowResults[idx];
    if (!fr || !fr.passed) continue;
    if (!fr.nozzleResults || fr.nozzleResults.length === 0) continue;

    doc.addPage(); pg++;

    // Header
    addLogo(doc, logoBase64, logoFormat, m, 8, 25, 25);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
    doc.text("FK 5112 Suppression System Report", m + 28, 18);

    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("System Performance Report", pw / 2, 42, { align: "center" });

    var encName = enclosureResults[idx].name || ("Enclosure " + (idx + 1));
    doc.setFontSize(11); doc.text(encName, m, 56);

    // Verified badge — simple green bar, no Unicode issues
    var badgeW = pw - m * 2;
    doc.setFillColor(5, 150, 105);
    doc.roundedRect(m, 60, badgeW, 12, 2, 2, "F");
    doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(255, 255, 255);
    doc.text("SYSTEM VERIFIED -- Design meets NFPA 2001 performance requirements", pw / 2, 68, { align: "center" });

    var y = 80;

    // System Acceptance Summary — use plain ASCII for symbols
    doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor.apply(doc, NAVY);
    doc.text("System Acceptance Summary", m, y); y += 6;

    var summaryData = [
      ["System Discharge Time", fr.dischargeTime.toFixed(1) + " seconds", "<= 10 seconds"],
      ["Percent Agent in Pipe", fr.pctAgentInPipe.toFixed(1) + "%", "<= 82.1%"],
      ["Percent Agent Before First Tee", fr.pctAgentBeforeFirstTee === "N/A" ? "N/A" : fr.pctAgentBeforeFirstTee.toFixed(1) + "%", fr.pctAgentBeforeFirstTee === "N/A" ? "N/A (no tee)" : ">= 9.3%"],
      ["Starting Cylinder Pressure", fr.startPressure.toFixed(1) + " bar", ""],
      ["Total Agent", Math.round(fr.agentKg * 2.20462) + " lbs", ""],
    ];

    autoTable(doc, {
      startY: y,
      head: [["Parameter", "Value", "NFPA Requirement"]],
      body: summaryData,
      margin: { left: m, right: m },
      headStyles: { fillColor: GREEN, textColor: WHITE, fontStyle: "bold", fontSize: 9 },
      bodyStyles: { fontSize: 9, textColor: [30, 30, 30] },
      alternateRowStyles: { fillColor: [240, 250, 245] },
      columnStyles: { 0: { cellWidth: 65 }, 1: { cellWidth: 40, halign: "right" }, 2: { cellWidth: 40, halign: "right" } },
    });

    y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y + 40) + 12;

    // Nozzle Performance Table
    doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor.apply(doc, NAVY);
    doc.text("Nozzle Performance", m, y); y += 6;

    var nozzleRows = fr.nozzleResults.map(function(nr, ni) {
      var nozzle = nr.selectedNozzle || {};
      return [
        "E" + (idx + 1) + "-N" + (ni + 1),
        nozzle.partNumber || "--",
        nozzle.nozzleSize || "--",
        nozzle.orificeAreaMM2 ? nozzle.orificeAreaMM2.toFixed(2) + " mm2" : "--",
        nr.pressure.toFixed(3) + " bar",
        nr.flowRateLbs.toFixed(2) + " lb/s",
        nr.agentDelivered ? nr.agentDelivered.toFixed(2) + " kg" : "--",
      ];
    });

    autoTable(doc, {
      startY: y,
      head: [["Nozzle", "Part Number", "Size", "Orifice Area", "Avg Pressure", "Flow Rate", "Agent Delivered"]],
      body: nozzleRows,
      margin: { left: m, right: m },
      headStyles: { fillColor: GREEN, textColor: WHITE, fontStyle: "bold", fontSize: 8 },
      bodyStyles: { fontSize: 8, textColor: [30, 30, 30] },
      alternateRowStyles: { fillColor: [240, 250, 245] },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 38, fontSize: 7 },
        2: { cellWidth: 18 },
        3: { cellWidth: 28, halign: "right" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 22, halign: "right" },
        6: { cellWidth: 27, halign: "right" },
      },
    });

    y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y + 30) + 12;

    // Node Pressure Table — sorted in logical order
    if (fr.nodePressures && Object.keys(fr.nodePressures).length > 0) {
      if (y > 220) { addFooter(doc, pg); doc.addPage(); pg++; y = 30; }
      doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor.apply(doc, NAVY);
      doc.text("Node Pressure Distribution", m, y); y += 6;

      var sortedKeys = sortNodeKeys(Object.keys(fr.nodePressures));
      var nodeRows = sortedKeys.map(function(key) {
        var pBar = fr.nodePressures[key];
        // Clean up node label for display
        var label = key.toUpperCase().replace("_", " ");
        return [label, pBar.toFixed(3) + " bar", (pBar * 14.5038).toFixed(1) + " psig"];
      });

      autoTable(doc, {
        startY: y,
        head: [["Node", "Pressure (bar)", "Pressure (psig)"]],
        body: nodeRows,
        margin: { left: m, right: m },
        headStyles: { fillColor: GREEN, textColor: WHITE, fontStyle: "bold", fontSize: 9 },
        bodyStyles: { fontSize: 9, textColor: [30, 30, 30] },
        alternateRowStyles: { fillColor: [240, 250, 245] },
        columnStyles: { 0: { cellWidth: 50, fontStyle: "bold" }, 1: { cellWidth: 50, halign: "right" }, 2: { cellWidth: 50, halign: "right" } },
      });
    }

    addFooter(doc, pg);
  }

  return pg;
}
